export default{
  "Mute Video": "Video Dempen",
  "HitPaw Online Mute Video": "HitPaw Online Video Dempen",
  "Fast and easy to remove sound from your video online": "Snel en eenvoudig online geluid uit uw video verwijderen",
  "Muting": "Mute",
  "Mute Failed": "Geluid uit Mislukt",
  "Mute New": "Dempen Nieuw"
};